import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      document.getElementById('offer-section')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button className={`bg-[#E8604C] text-white font-sans font-bold py-4 px-8 rounded-full transition-all duration-300 hover:bg-[#d65542] animate-gentle-pulse focus:outline-none focus:ring-4 focus:ring-[#E8604C]/30 ${className}`} onClick={handleClick} {...props} data-id="element-132">
      {children}
    </button>;
}